module.exports = __webpack_public_path__ + "img/3.8c9eaf2e.jpg";